import { tradeSubscriberRoutes } from './tradeSubscriberRoutes';
import { productRoutes } from './productRoutes';
import { cancelRoutes } from './cancelRoutes';
import { cartRoutes } from './cartRoutes';
import { discountRoutes } from './discountRoutes';
import { exchangeRoutes } from './exchangeRoutes';
import { featureRoutes } from './featureRoutes';
import { featureItemRoutes } from './featureItemRoutes';
import { inventoryCategoryRoutes } from './inventoryCategoryRoutes';
import { inventoryRoutes } from './inventoryRoutes';
import { orderRoutes } from './orderRoutes';
import { priceRoutes } from './priceRoutes';
import { productCategoryRoutes } from './productCategoryRoutes';
import { orderPaymentRoutes } from './orderPaymentRoutes';
import { requestRoutes } from './requestRoutes';
import { refundRoutes } from './refundRoutes';
import { returnsRoutes } from './returnsRoutes';
import { wishRoutes } from './wishRoutes';
import { categoryRoutes } from './categoryRoutes';
import { messageRoutes } from './messageRoutes';
import { featureCategoryRoutes } from './featureCategoryRoutes';
import { tradeShippingRoutes } from './tradeShippingRoutes';
import { newsRoutes } from 'src/router/trade/newsRoutes';
import { tradeSurveyRoutes } from 'src/router/trade/tradeSurveyRoutes';
import { tradeSupportRoutes } from 'src/router/trade/tradeSupportRoutes';

export const tradeRoutes = [
  ...categoryRoutes,
  ...messageRoutes,
  ...cancelRoutes,
  ...cartRoutes,
  ...discountRoutes,
  ...exchangeRoutes,
  ...featureCategoryRoutes,
  ...featureItemRoutes,
  ...featureRoutes,
  ...inventoryCategoryRoutes,
  ...inventoryRoutes,
  ...orderRoutes,
  ...priceRoutes,
  ...productCategoryRoutes,
  ...productRoutes,
  ...orderPaymentRoutes,
  ...requestRoutes,
  ...returnsRoutes,
  ...refundRoutes,
  ...tradeSubscriberRoutes,
  ...wishRoutes,
  ...tradeShippingRoutes,
  ...newsRoutes,
  ...tradeSurveyRoutes,
  ...tradeSupportRoutes,
];
